import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryLogRoutingModule } from './history-log-routing.module';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule, MultiSelectModule} from "primeng/primeng";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';
import {HistoryLogComponent} from './history-log.component';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule,
    TranslateModule,
    MultiSelectModule,
    //HistoryLogRoutingModule
  ],
  exports: [
    HistoryLogComponent
  ],
  declarations: [HistoryLogComponent]
})
export class HistoryLogModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.module.ts